const Data = [
    {
        name: "Anshu Goyal",
        position: "President",
        imageUrl: "/assets/images/members/GB24/Anshu Goyal.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100073931382044",
        linkedinLink: "https://www.linkedin.com/in/anshu-goyal-9a4a04222",
        email: 'anshu.goyal@gyws.org',
    },
    {
        name: "Shivam Yadav",
        position: "Vice President",
        imageUrl: "/assets/images/members/GB24/Shivam Yadav.png",
        facebookLink: "https://www.facebook.com/Shivam.satmanju",
        linkedinLink: "https://www.linkedin.com/in/shivamyadav1710",
        email: "shivam.yadav@gyws.org"
    },
    {
        name: "Sumit Deora",
        position: "General Secretary",
        imageUrl: "/assets/images/members/GB24/Sumit Deora.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100006783194680",
        linkedinLink: "https://www.linkedin.com/in/sumit-deora-0b209921b/",
        email: "sumit.deora@gyws.org"
    },
    {
        name: "Ajay Paliwal",
        position: "Assistant Secretary ",
        imageUrl: "/assets/images/members/GB24/Ajay Paliwal.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100075660422516",
        linkedinLink: "https://www.linkedin.com/in/ajay-paliwal-b7a9b8223/",
        email: "ajay.paliwal@gyws.org"
    },
    {
        name: "Virat Dwivedi",
        position: "Human Resource Manager",
        imageUrl: "/assets/images/members/GB24/ViratD.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100006798225731",
        linkedinLink: "https://www.linkedin.com/in/virat-dwivedi-55912a202/",
        email: "virat.dwivedi@gyws.org"
    },
    {
        name: "Advait Gokhale",
        position: "Chief Executive Officer, LiGHT",
        imageUrl: "/assets/images/members/GB24/Advait Gokhale.png",
        facebookLink: "https://www.facebook.com/profile.php?id=100074639880196",
        linkedinLink: "https://www.linkedin.com/in/advait-gokhale-399a0b236/",
        email: "advait.gokhale@gyws.org"
    },
    {
        name: "Ujjawal Kumar",
        position: "Chief Technical Officer",
        imageUrl: "/assets/images/members/GB24/Ujjawal Kumar.png",
        facebookLink: "https://www.facebook.com/profile.php?id=100012980770787",
        linkedinLink: "https://www.linkedin.com/in/ujjawal-kumar-45a431228/",
        email: "ujjawal.kumar@gyws.org"
    },
    {
        name: "Ishika Modi",
        position: "Treasurer",
        imageUrl: "/assets/images/members/GB24/Ishika Modi.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100075462040432",
        linkedinLink: "https://www.linkedin.com/in/ishika-modi-117354227/", 
        email: "ishika.modi@gyws.org"
    },
    {
        name: "Amisha Rathi",
        position: "School Development Officer ",
        imageUrl: "/assets/images/members/GB24/Amisha Rathi.jpg",
        facebookLink: "https://www.facebook.com/amisha.rathi.545",
        linkedinLink: "https://www.linkedin.com/in/amisha-rathi/",
        email: "amisha.r@gyws.org"
    },
    {
        name: "Nitin Rajvanshi",
        position: "Chief Fundraising Officer",
        imageUrl: "/assets/images/members/GB24/Nitin Rajvanshi.jpg",
        facebookLink: "https://www.facebook.com/nitinraj72",
        linkedinLink: "https://www.linkedin.com/in/nitinrajvanshi/",
        email: "nitin.rajvanshi@gyws.org"
    },
    {
        name: "Arpit Singh",
        position: "Foreign and Corporate Relation Officer",
        imageUrl: "/assets/images/members/GB24/Arpit Singh.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100073612406522",
        linkedinLink: "https://www.linkedin.com/in/arpit-singh-a08146224/",
        email: "arpit.singh@gyws.org"
    },
    {
        name: "Hrishikesh M V",
        position: "Donor Engagement Officer",
        imageUrl: "/assets/images/members/GB24/Hrishikesh M V.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100004918995599",
        linkedinLink: "https://www.linkedin.com/in/hrishikesh-m-v-288a62227/",
        email: 'hrishikesh.mv@gyws.org'
    },
    {
        name: "Ujjwal Kumar Singh",
        position: "Public Relation Officer",
        imageUrl: "/assets/images/members/GB24/Ujjwal Kumar Singh.jpeg",
        facebookLink: "http://facebook.com/profile.php?id=100074018137550",
        linkedinLink: "https://www.linkedin.com/in/ujjwalkumarsingh/",
        email: "ujjwal.singh@gyws.org"
    }

]

export default Data;